export default {
  clearSearch: 'Clear Search',
  search: 'Search',
  all: 'All',
  or: ' or ',
  yes: 'Yes',
  no: 'No',
  appleStore: 'Apple Store',
  reward: 'REWARD ',
  rmb: '￥',
  serverError: 'server error, please contact administrator',
  label: {
    now: 'Now',
    operate: 'Action',
    sortOperate: 'Sort',
    yes: 'Yes',
    no: 'No',
    status: 'Status',
    agreed: 'Agreed',
    noAgreed: 'NoAgreed',
    comment: 'Comment',
    selectAll: 'All',
    agreePolicy: 'I agree',
    noData: 'No Data',
    english: 'English',
    chinese: 'Chinese',
    have: 'Have',
    notHave: 'Not Have'
  },
  separator: {
    or: ' or '
  },
  date: {
    yesterday: 'Yesterday'
  },
  btn: {
    ok: 'OK',
    confirm: 'Confirm',
    save: 'Save',
    cancel: 'Cancel',
    edit: 'Edit',
    add: 'Add',
    move: 'Move',
    remove: 'Remove',
    delete: 'Delete',
    enable: 'Enable',
    disable: 'Disable',
    select: 'Select',
    last: 'Last',
    prev: 'Previous',
    next: 'Next',
    submit: 'Submit',
    download: 'Download',
    copy: 'Copy',
    back: 'Back',
    expand: 'Expand',
    collapse: 'Collapse',
    replace: 'Replace',
    clear: 'Clear',
    share: 'Share',
    preview: 'Preview',
    view: 'View',
    placeholder: 'Placeholder',
    invite: 'Invite',
    send: 'Send',
    export: 'Export',
    search: 'Search',
    action: 'Action',
    yesInvite: 'Yes',
    noInvite: 'No',
    apply: 'Apply',
    signIn: 'Sign In',
    refresh: 'Refresh',
    clickToUpload: 'Click to Upload',
    generate: 'Generate',
    reject: 'Reject',
    accept: 'Accept'
  },
  message: {
    wrongImageType: 'Please upload an image file.',
    wrongImageSize: 'Please upload an image file no larger than {size}MB.',
    pcAndMobileImageRequired: 'Please add PC and mobile images',
    uploadError: 'Upload failed, please try again later',
    unSaveChangeConfirm: 'The modification has not been saved. Are you sure you want to discard it?',
    requiredFormField: 'This field is required',
    InvalidMaxLength: 'The length is no more than {max} characters',
    invalidEmail: 'Email is invalid',
    invalidMobile: 'Mobile is invalid',
    invalidPwd: 'Password must contain small letter, capital letter and number, and at least 10 digit, symbol can only use _#@.-',
    passwordNotSame: 'Two passwords are not same',
    needAgreePolicy: 'Before signing up, you must agree to the terms',
    needLoginAgreePolicy: 'Before logging in, you must agree to the terms.',
    sendSuccess: 'Send Success!',
    sendFail: 'Send Fail, please try again later!',
    saveSuccess: 'Save Success!',
    saveFail: 'Save Fail, please try again later!',
    actionSuccess: '{action} Success!',
    actionFail: '{action} Fail, please try again later!',
    actionConfirm: 'Are you sure you want to {action} this?',
    continueWithAgreePolicy: 'Please agree to the terms to continue',
    revokeCurrentPosition: 'Do you want to revoke your current position?',
    revokeAllApplicationTip: 'Do you confirm to revoke your data?',
    downloadResource: {
      VIDEO_POSTER: 'Tap here to open in your browser and download the video poster!'
    },
    invalidIDCardNumber: 'ID Number is invalid',
    mobileOnlySupport: 'The mobile only support digits, +, -, and ()',
    emptyName: 'First name is empty.',
    noMatchedData: 'No Matches',
    inviteSuccess: 'Your invitation(s) have been successfully sent.',
    inviteFailed: 'Your invitation(s) have been failed sent.',
    copyLink: 'Press Ctrl+C to copy the URL',
    submitSuccess: 'Successfully submitted.',
    agreeSystemPolicyWarning: ' Please agree to the terms to continue.',
    selectDisabledHmWarning: 'The HM account is disabled. Please enable it. Contact your administrator or your AJINGA customer success consultant for support. ',
    confirmDelete: 'Are you sure you want to delete this?',
    refreshPageWithoutSaveData: 'Please click OK to leave the page (any data you have entered will be lost).\nPlease click CANCEL to stay on this page.',
    inviteInterviewFail: 'Oops, you cannot invite candidate(s) in {statusName} for interview. Contact your administrator or your AJINGA customer success consultant for support.',
    revokeAllApplication: 'PLEASE be kindly noted that by saving this, you will revoke the consent to us and all your applications will be deleted.',
    logoff: 'PLEASE be kindly noted that by saving this, you will revoke the consent to the system and your account will be closed.',
    nameHasExist: 'The name has already been used.',
    shareJobLoginFail: 'Login fail. Please generate the QR code again on desktop and scan.',
    mapLoadFail: 'Oops, that didn\'t work, but it\'s not you, it is us! Please click the map icon to try again.',
    optionSuccess: 'Option Success!',
    invalidNumber: 'Please enter the correct score number',
    downloadSuccess: 'Download Success!',
    downloadFailed: 'Download failed, please try again later!',
    exportFailed: 'Export failed, please try again later!',
    success: 'Success',
    error: 'Error',
    warning: 'Warning'
  },
  gender: {
    male: 'Male',
    female: 'Female',
    nonBinary: 'Non Binary',
    preferNotToDisclose: 'Prefer not to disclose'
  },
  upload: {
    tipMessage: {
      addHeaderImage: {
        pc: 'Add PC Header Image',
        mobile: 'Add Mobile Header Image'
      }
    }
  },
  conditionType: {
    include: 'Include',
    exclude: 'Exclude',
    equal: 'Equal',
    notEqual: 'Not equal'
  },
  dateShortcut: {
    today: 'Today',
    yesterday: 'Yesterday',
    lastWeek: 'Last Week',
    lastMonth: 'Last Month',
    last3Month: 'Last 3 Months',
    last6Month: 'Last 6 Months',
    lastYear: 'Last Year',
    thisYear: 'This Year'
  }
}
